<style lang="scss" scoped>
.PreviewCustomer {
  width: 375px;
  height: 705px;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  overflow: hidden;
  img {
    width: 100%;
  }
  .box {
    position: relative;
    // top: -125px;
    padding: 125px 25px 0 25px;
    width: 100%;
    height: 110%;
    background-image: url(../../../assets/img/guideShopshelf/PreviewCustomer.png);
  }
  .pa {
    position: absolute;
  }
  .name {
    top: 97px;
    left: 80px;
  }
  .nickName {
    top: 118px;
    left: 80px;
  }
  .phone {
    top: 176px;
    left: 80px;
  }
  .order {
    top: 259px;
    left: 35px;
    font-size: 15px;
    border-bottom: 2px solid;
  }
}
</style>
<template>
  <div class="PreviewCustomer">
    <div class="box">
      <div
        class="pa name"
        :style="{ 'color': contentColor }"
      >
        会员名称
      </div>
      <div
        class="pa nickName"
        :style="{ 'color': contentColor }"
      >
        微信昵称：会员微信昵称
      </div>
      <div
        class="pa phone"
        :style="{ 'color': contentColor }"
      >
        基础信息：18888888888
      </div>
      <div
        class="pa order"
        :style="{ 'color': primaryColor }"
      >
        客户订单
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewCustomer',
  props: {
    primaryColor: {
      type: String,
      default: '#fff'
    },
    contentColor: {
      type: String,
      default: '#fff'
    }
  },
  data () {
    return {
      showImgPicker: false
    }
  },
  created () {},
  methods: {
    handleClickChangeImage () {
      this.showImgPicker = true
    },
    onClosePicker () {
      this.showImgPicker = false
    },
    onChangePicker (data) {
      console.log(`onChangePicker:`, data)
      this.showImgPicker = false
      if (data.length > 0) {
        this.value.img = data[0].image_url
      }
      this.$emit('input', this.value)
    }
  }
}
</script>
